export default function CloseMarketIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="4" fill="#E0485C" fill-opacity="0.2" />
      <rect x="4" y="4" width="8" height="8" rx="2" fill="#ED7685" />
    </svg>
  )
}
